<template>
  <div class="TenantSettingModal">
    <el-dialog
        title="机构配置"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="30%"
        :center="true"
        @open="handleOpen"
    >
      <el-form :model="formData" ref="form" :rules="rules" label-width="90px">
        <el-form-item label="上传Logo">
          <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-success="handleAvatarSuccess"
              :on-change="handleImgChange"
              :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div>
              <el-button
                  class="btn"
                  v-if="imageUrl"
                  size="mini"
                  plain
                  type="primary"
                  slot="trigger"
              >上传更换
              </el-button>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="机构名" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="工具横幅:" prop="assistTitle">
            <el-input type="textarea" v-model="formData.assistTitle"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
            plain
            size="small"
            style="width: 30%; display: inline-block"
            type="primary"
            @click="handleClose"
        >取消</el-button
        >
        <el-button
            size="small"
            style="width: 30%; display: inline-block"
            type="primary"
            @click="handleConfirm"
        >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "TenantSettingModal",
  data() {
    return {
      imageUrl: "",
      formData: {
        filename: "",
        materialId: null,
        name: "",
        assistTitle: "",
      },
      rules: {
        name: [
          {
            required: false,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ]
      },
    };
  },
  computed: {
    ...mapState("tenant", ["ossUploadObj", "tenantSettingModalVisible", "tenantInfo"]),
    visible: {
      get() {
        return this.$store.state.tenant.tenantSettingModalVisible;
      },
      set(value) {
        this.$store.commit("tenant/setData", {
          key: "tenantSettingModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapActions("tenant", ["getUserTenants", "saveTenantConfig", "getTenantConfig"]),
    ...mapMutations("tenant", ["setData"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    async handleImgChange(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      this.formData.filename = this.ossUploadObj.filename;
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      
      await this.$axios({
        url: this.ossUploadObj.url,
        withCredentials: false,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
          })
          .catch((e) => {
            console.log(e);
          });
    },
    async handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传Logo图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleClose() {
      this.setData({key: "tenantSettingModalVisible", value: false});
    },
    handleOpen() {
      console.log('handleOpen')
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      Object.keys(this.formData).map((key) => {
        this.formData[key] = this.tenantInfo[key];
      });
      this.imageUrl = this.tenantInfo.materialUrl;
      this.formData.avatar = null;
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.setData({key: "tenantSettingModalVisible", value: false});
          await this.$refs.form.validate(async (valid) => {
            if (valid) {
              await this.saveTenantConfig({
                ...this.formData,
              });
              await this.getTenantConfig();
              this.$message.success("操作成功");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AccountSettingModal {
  ::v-deep .el-dialog {
    min-width: 420px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
  }

  .btn {
    text-align: right;
  }
}
</style>
